import { PrintPreviewPage } from './../print-preview/print-preview';
import { Component } from '@angular/core';
import { NavController } from 'ionic-angular';
import { DocumentParserProvider } from '../../providers/document-parser/document-parser';
import { DataServiceProvider } from '../../providers/data-service/data-service';
import { BillingPage } from '../billing/billing';

@Component({
  selector: 'page-home',
  templateUrl: 'home.html'
})
export class HomePage {
  records: any[];
  initialReportUpload = false;
  finalReportUpload = false;
  operatorText: string = '';
  showCustomerForm = true;
  // hide the theoritical air flow for current itteration 
  showTheoriticalAirFlow = false;
  customerData: any = {};
  constructor(public navCtrl: NavController,
    public $pdfParser: DocumentParserProvider,
    public $data: DataServiceProvider) {
    this.records = this.$data.getItems();
    console.log('the data from service', this.records);
  }


  onFormProceed($event) {
    console.log('the form data is', $event);
    this.showCustomerForm = false;
    this.customerData = $event;
  }

  firstSelect($event) {
    console.log('file select has happend');
    //this.$pdfParser.handleFileSelect($event);
    this.$pdfParser.handelFileSelection($event).then(data => {
      console.log('the text data', data);
    })
  }

  uploadInitalReport($event) {
    this.$pdfParser.handelFileSelection($event).then((data: string[]) => {
      console.log('the text data', data);
      this.$data.fillInitialValues(this.records, data);
      this.customerData.readyForEmissionTest = this.$data.isReadyForEmissionTest(data);
      this.generateRemarks(this.records);
      this.initialReportUpload = true;
    })
  }

  uploadFinalReport($event) {
    this.$pdfParser.handelFileSelection($event).then((data: string[]) => {
      console.log('the text data', data);
      this.$data.fillFinalValues(this.records, data);
      this.generateRemarks(this.records);
      this.finalReportUpload = true;
    })
  }

  getTheData() {
    let data = this.$data.getItems();
    console.log('hai there:', data);
  }

  getUnit(unit, value) {
    return unit != 'N.A' && value > 0 ? unit : '';
  }

  generateRemarks(records: any[]) {
    return records.map(record => {
      record.remark = record.initialValue > 0 && record.finalValue > 0 ?
        record.finalValue - record.initialValue >= 0 ?
          record.finalValue - record.initialValue == 0 ?
            'No Change' :
            'Increased' :
          'Decreased' :
        'N.A';
      return record;
    })
  }

  // business rules to show and hide a data
  isShowable(record) {
    if (record.settingsValue == "Show Always") {
      return true;
    }
    if (record.settingsValue == "Hide Always") {
      return false;
    }
    else if (record.remark == "Increased" && record.settingsValue == "Show Decreased") {
      return false;
    }
    else if (record.remark == "Decreased" && record.settingsValue == "Show Increased") {
      return false;
    } else {
      return true;
    }
  }

  /**
   * makes a conclusion string 
   * @param item 
   */
  getConclusion(record): string {
    return this.$data.getRecordRemark(record);
  }

  getTheoritcalAirFlow(): number {
    return this.$data.getTheoriticalAirFlow(this.customerData.engineDisplacement, this.customerData.engineRpm);
  }

  printButtonClick() {
    console.log('print button clicked');
    let previewData: any = {};
    previewData.records = this.records;
    previewData.operatorText = this.operatorText;
    previewData.customerData = this.customerData;
    this.navCtrl.push(PrintPreviewPage, { previewData: previewData });
  }

  goToBilling() {
    let previewData: any = {};
    previewData.records = this.records;
    previewData.operatorText = this.operatorText;
    previewData.customerData = this.customerData;
    this.navCtrl.push(BillingPage, { previewData: previewData });
  }

}



// WEBPACK FOOTER //
// ./src/pages/home/home.ts